export const listNotificationsApi = ({ unread, cursor } = {}) => {
    if (cursor) {
        return fetch(cursor, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': window.csrf_token },
        });
    }

    const params = new URLSearchParams();
    if (unread) params.set('unread', 'true');
    const query = params.toString();

    return fetch(`/api/v1/notifications/${query ? `?${query}` : ''}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': window.csrf_token },
    });
};

export const getUnreadCountApi = (etag) =>
    fetch('/api/v1/notifications/unread-count/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
            ...(etag ? { 'If-None-Match': etag } : {}),
        },
    });

export const markNotificationReadApi = (notificationId) =>
    fetch(`/api/v1/notifications/${notificationId}/read/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': window.csrf_token },
    });

export const markAllNotificationsReadApi = () =>
    fetch('/api/v1/notifications/read-all/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': window.csrf_token },
    });
